import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";

import { Cancel, CallForHelp, PhonePad } from "../../../../../components";

import AuthenticationHelp from "../AuthenticationHelp";
import AuthenticationError from "../AuthenticationError";

import Service from "./service";

const SUBSCREENS = {
  MAIN: 1,
  HELP: 2,
  CANCEL: 3,
  CALL_FOR_HELP: 4,
  ERROR: 5,
};

class EnterPhoneScreen extends Component {
  state = {
    screen: SUBSCREENS.MAIN,
    loading: false,
  };

  goToHelp = () => this.setState({ screen: SUBSCREENS.HELP });
  goToCancel = () => this.setState({ screen: SUBSCREENS.CANCEL });
  goBack = () => this.setState({ screen: SUBSCREENS.MAIN });
  goToCallForHelp = () => this.setState({ screen: SUBSCREENS.CALL_FOR_HELP });
  goToErrorScreen = () => this.setState({ screen: SUBSCREENS.ERROR });

  handleGetCommunicationChannels = phone_nr => {
    const { match, onGoToConfirmAuthenticationScreen } = this.props;

    this.setState({ loading: true }, () => {
      Service.getCommunicationChannels({ phone_nr, private_key: match.params.keylockerKey })
        .then(response => {
          this.setState({ loading: false }, () => {
            if (response?.data?.data)
              onGoToConfirmAuthenticationScreen({
                phone_nr,
                displayedPhoneNr: response.data.data.phone_nr,
                emailAddress: response.data.data.email_address,
                appointment_id: response.data.data.appointment_id,
              });
            else this.goToErrorScreen();
          });
        })
        .catch(err => {
          this.setState({ loading: false }, () => this.goToErrorScreen());
        });
    });
  };

  render() {
    const { screen, loading } = this.state;
    const { renderLayout, onAbort, onGoBack, t } = this.props;

    switch (screen) {
      default:
      case SUBSCREENS.MAIN:
        return (
          <PhonePad
            onBackCancel={onGoBack}
            onGoToHelpScreen={this.goToHelp}
            onGoToCancelScreen={this.goToCancel}
            rightButtonText={t("kl_next").message || "Next"}
            renderLayout={renderLayout}
            onConfirm={this.handleGetCommunicationChannels}
            loading={loading}
          />
        );

      case SUBSCREENS.HELP:
        return <AuthenticationHelp renderLayout={renderLayout} onGoBack={this.goBack} onGoToCallForHelp={this.goToCallForHelp} />;

      case SUBSCREENS.CANCEL:
        return <Cancel onGoBack={this.goBack} onAbort={onAbort} />;

      case SUBSCREENS.CALL_FOR_HELP:
        return <CallForHelp onGoBack={this.goToHelp} />;

      case SUBSCREENS.ERROR:
        return (
          <AuthenticationError
            renderLayout={renderLayout}
            onGoBack={this.goBack}
            onGoToHelpScreen={this.goToHelp}
            onGoToCallForHelp={this.goToCallForHelp}
            message={t("kl_authentication_error").message || "We could not find your appointment or we do not have your contact information to send you a PIN code."}
          />
        );
    }
  }
}

export default withRouter(withTranslation()(EnterPhoneScreen));
